// extracted by mini-css-extract-plugin
module.exports = {"currency":"Balance_currency__31_Pn"};